var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/search-bar/search-bar.html';
var html = "<div class=\"col-lg-12 col-md-12 col-sm-12 remove-padding search-bar-container\"> <input type=text class=search-input ng-model=$ctrl.searchKeyword placeholder={{$ctrl.placeholder}} ng-keyup=$ctrl.onSearch($event) /> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/search-bar/search-bar.html
// module id = 926
// module chunks = 0